import React from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setLogout } from '../../Redux/Feature/loginSlice';

export default function SidebarTab({ value, active, profile, setActive, setProfile, setCollapse, setSelectedTimesheet }) {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    function capitalizeFirstLetter(str) {
        return str[0].toUpperCase() + str.slice(1);
    }

    const svg = {
        "dashboard": (
            <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-4"
            >
                <path
                    d="M12.2222 6.11111V1.22222C12.2222 0.875926 12.3396 0.585444 12.5742 0.350778C12.8081 0.116926 13.0981 0 13.4444 0H20.7778C21.1241 0 21.4141 0.116926 21.648 0.350778C21.8827 0.585444 22 0.875926 22 1.22222V6.11111C22 6.45741 21.8827 6.74748 21.648 6.98133C21.4141 7.216 21.1241 7.33333 20.7778 7.33333H13.4444C13.0981 7.33333 12.8081 7.216 12.5742 6.98133C12.3396 6.74748 12.2222 6.45741 12.2222 6.11111ZM0 11V1.22222C0 0.875926 0.117333 0.585444 0.352 0.350778C0.585852 0.116926 0.875926 0 1.22222 0H8.55556C8.90185 0 9.19233 0.116926 9.427 0.350778C9.66085 0.585444 9.77778 0.875926 9.77778 1.22222V11C9.77778 11.3463 9.66085 11.6364 9.427 11.8702C9.19233 12.1049 8.90185 12.2222 8.55556 12.2222H1.22222C0.875926 12.2222 0.585852 12.1049 0.352 11.8702C0.117333 11.6364 0 11.3463 0 11ZM12.2222 20.7778V11C12.2222 10.6537 12.3396 10.3632 12.5742 10.1286C12.8081 9.8947 13.0981 9.77778 13.4444 9.77778H20.7778C21.1241 9.77778 21.4141 9.8947 21.648 10.1286C21.8827 10.3632 22 10.6537 22 11V20.7778C22 21.1241 21.8827 21.4141 21.648 21.648C21.4141 21.8827 21.1241 22 20.7778 22H13.4444C13.0981 22 12.8081 21.8827 12.5742 21.648C12.3396 21.4141 12.2222 21.1241 12.2222 20.7778ZM0 20.7778V15.8889C0 15.5426 0.117333 15.2521 0.352 15.0174C0.585852 14.7836 0.875926 14.6667 1.22222 14.6667H8.55556C8.90185 14.6667 9.19233 14.7836 9.427 15.0174C9.66085 15.2521 9.77778 15.5426 9.77778 15.8889V20.7778C9.77778 21.1241 9.66085 21.4141 9.427 21.648C9.19233 21.8827 8.90185 22 8.55556 22H1.22222C0.875926 22 0.585852 21.8827 0.352 21.648C0.117333 21.4141 0 21.1241 0 20.7778Z"
                    fill={active === "dashboard" && !profile ? "white" : "black"}
                />
            </svg>),
        "timesheets": (
            <svg
                width="19"
                height="20"
                viewBox="0 0 19 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-4"
            >
                <path
                    d="M2 17V6V17ZM2 19C1.45 19 0.979333 18.8043 0.588 18.413C0.196 18.021 0 17.55 0 17V6C0 5.45 0.196 4.97933 0.588 4.588C0.979333 4.196 1.45 4 2 4H6V2C6 1.45 6.196 0.979 6.588 0.587C6.97933 0.195667 7.45 0 8 0H12C12.55 0 13.021 0.195667 13.413 0.587C13.8043 0.979 14 1.45 14 2V4H18C18.55 4 19.021 4.196 19.413 4.588C19.8043 4.97933 20 5.45 20 6V10.275C19.7 10.0583 19.3833 9.87067 19.05 9.712C18.7167 9.554 18.3667 9.41667 18 9.3V6H2V17H9.075C9.125 17.35 9.2 17.6917 9.3 18.025C9.4 18.3583 9.525 18.6833 9.675 19H2ZM8 4H12V2H8V4ZM16 21C14.6167 21 13.4377 20.5127 12.463 19.538C11.4877 18.5627 11 17.3833 11 16C11 14.6167 11.4877 13.4373 12.463 12.462C13.4377 11.4873 14.6167 11 16 11C17.3833 11 18.5627 11.4873 19.538 12.462C20.5127 13.4373 21 14.6167 21 16C21 17.3833 20.5127 18.5627 19.538 19.538C18.5627 20.5127 17.3833 21 16 21ZM17.65 18.35L18.35 17.65L16.5 15.8V13H15.5V16.2L17.65 18.35Z"
                    fill={active === "timesheets" && !profile ? "white" : "black"}
                />
            </svg>),
        "find-jobs": (
            <svg
                width="19"
                height="20"
                viewBox="0 0 19 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-4"
            >
                <path
                    d="M18.6248 18.6625L13.5373 13.575C14.5686 12.2 15.1873 10.4812 15.1873 8.625C15.1873 4.0875 11.4748 0.375 6.9373 0.375C4.66855 0.375 2.5373 1.26875 0.956055 2.9875L1.9873 3.95C3.2248 2.50625 5.0123 1.75 6.9373 1.75C10.7186 1.75 13.8123 4.84375 13.8123 8.625C13.8123 12.4062 10.7186 15.5 6.9373 15.5C4.8748 15.5 2.9498 14.6062 1.64355 13.025L0.612305 13.9188C2.1248 15.775 4.4623 16.875 6.9373 16.875C9.1373 16.875 11.1311 15.9813 12.6436 14.6063L17.6623 19.625L18.6248 18.6625Z"
                    fill={active === "find-jobs" && !profile ? "white" : "black"}
                />
            </svg>
        ),
        "discover": (
            <svg
                width="19"
                height="20"
                viewBox="0 0 19 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-4"
            >
                <path
                    d="M18.6248 18.6625L13.5373 13.575C14.5686 12.2 15.1873 10.4812 15.1873 8.625C15.1873 4.0875 11.4748 0.375 6.9373 0.375C4.66855 0.375 2.5373 1.26875 0.956055 2.9875L1.9873 3.95C3.2248 2.50625 5.0123 1.75 6.9373 1.75C10.7186 1.75 13.8123 4.84375 13.8123 8.625C13.8123 12.4062 10.7186 15.5 6.9373 15.5C4.8748 15.5 2.9498 14.6062 1.64355 13.025L0.612305 13.9188C2.1248 15.775 4.4623 16.875 6.9373 16.875C9.1373 16.875 11.1311 15.9813 12.6436 14.6063L17.6623 19.625L18.6248 18.6625Z"
                    fill={active === "discover" && !profile ? "white" : "black"}
                />
            </svg>
        ),
        "jobs": (
            <svg
                width="19"
                height="20"
                viewBox="0 0 19 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-4"
            >
                <path
                    d="M2 17V6V17ZM2 19C1.45 19 0.979333 18.8043 0.588 18.413C0.196 18.021 0 17.55 0 17V6C0 5.45 0.196 4.97933 0.588 4.588C0.979333 4.196 1.45 4 2 4H6V2C6 1.45 6.196 0.979 6.588 0.587C6.97933 0.195667 7.45 0 8 0H12C12.55 0 13.021 0.195667 13.413 0.587C13.8043 0.979 14 1.45 14 2V4H18C18.55 4 19.021 4.196 19.413 4.588C19.8043 4.97933 20 5.45 20 6V10.275C19.7 10.0583 19.3833 9.87067 19.05 9.712C18.7167 9.554 18.3667 9.41667 18 9.3V6H2V17H9.075C9.125 17.35 9.2 17.6917 9.3 18.025C9.4 18.3583 9.525 18.6833 9.675 19H2ZM8 4H12V2H8V4ZM16 21C14.6167 21 13.4377 20.5127 12.463 19.538C11.4877 18.5627 11 17.3833 11 16C11 14.6167 11.4877 13.4373 12.463 12.462C13.4377 11.4873 14.6167 11 16 11C17.3833 11 18.5627 11.4873 19.538 12.462C20.5127 13.4373 21 14.6167 21 16C21 17.3833 20.5127 18.5627 19.538 19.538C18.5627 20.5127 17.3833 21 16 21ZM17.65 18.35L18.35 17.65L16.5 15.8V13H15.5V16.2L17.65 18.35Z"
                    fill={active === "jobs" && !profile ? "white" : "black"}
                />
            </svg>
        ),
        "consultants": (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6 mr-3"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
                />
            </svg>
        ),
        "vendors": (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6 mr-3"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
                />
            </svg>
        ),
        "clients": (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6 mr-3"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
                />
            </svg>
        ),
        "invoices": (
            <svg
                width="21"
                height="16"
                viewBox="0 0 21 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-4"
            >
                <path
                    d="M14.25 10.5C14.0511 10.5 13.8603 10.579 13.7197 10.7197C13.579 10.8603 13.5 11.0511 13.5 11.25C13.5 11.4489 13.579 11.6397 13.7197 11.7803C13.8603 11.921 14.0511 12 14.25 12H17.25C17.4489 12 17.6397 11.921 17.7803 11.7803C17.921 11.6397 18 11.4489 18 11.25C18 11.0511 17.921 10.8603 17.7803 10.7197C17.6397 10.579 17.4489 10.5 17.25 10.5H14.25ZM0 3.75C0 2.75544 0.395088 1.80161 1.09835 1.09835C1.80161 0.395088 2.75544 0 3.75 0H17.25C18.2446 0 19.1984 0.395088 19.9016 1.09835C20.6049 1.80161 21 2.75544 21 3.75V11.25C21 12.2446 20.6049 13.1984 19.9016 13.9017C19.1984 14.6049 18.2446 15 17.25 15H3.75C2.75544 15 1.80161 14.6049 1.09835 13.9017C0.395088 13.1984 0 12.2446 0 11.25V3.75ZM19.5 4.5V3.75C19.5 3.15326 19.2629 2.58097 18.841 2.15901C18.419 1.73705 17.8467 1.5 17.25 1.5H3.75C3.15326 1.5 2.58097 1.73705 2.15901 2.15901C1.73705 2.58097 1.5 3.15326 1.5 3.75V4.5H19.5ZM1.5 6V11.25C1.5 11.8467 1.73705 12.419 2.15901 12.841C2.58097 13.2629 3.15326 13.5 3.75 13.5H17.25C17.8467 13.5 18.419 13.2629 18.841 12.841C19.2629 12.419 19.5 11.8467 19.5 11.25V6H1.5Z"
                    fill={active === "invoices" && !profile ? "white" : "black"}
                />
            </svg>
        ),
        "my-jobs": (
            <svg
                width="21"
                height="16"
                viewBox="0 0 21 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-4"
            >
                <path
                    d="M14.25 10.5C14.0511 10.5 13.8603 10.579 13.7197 10.7197C13.579 10.8603 13.5 11.0511 13.5 11.25C13.5 11.4489 13.579 11.6397 13.7197 11.7803C13.8603 11.921 14.0511 12 14.25 12H17.25C17.4489 12 17.6397 11.921 17.7803 11.7803C17.921 11.6397 18 11.4489 18 11.25C18 11.0511 17.921 10.8603 17.7803 10.7197C17.6397 10.579 17.4489 10.5 17.25 10.5H14.25ZM0 3.75C0 2.75544 0.395088 1.80161 1.09835 1.09835C1.80161 0.395088 2.75544 0 3.75 0H17.25C18.2446 0 19.1984 0.395088 19.9016 1.09835C20.6049 1.80161 21 2.75544 21 3.75V11.25C21 12.2446 20.6049 13.1984 19.9016 13.9017C19.1984 14.6049 18.2446 15 17.25 15H3.75C2.75544 15 1.80161 14.6049 1.09835 13.9017C0.395088 13.1984 0 12.2446 0 11.25V3.75ZM19.5 4.5V3.75C19.5 3.15326 19.2629 2.58097 18.841 2.15901C18.419 1.73705 17.8467 1.5 17.25 1.5H3.75C3.15326 1.5 2.58097 1.73705 2.15901 2.15901C1.73705 2.58097 1.5 3.15326 1.5 3.75V4.5H19.5ZM1.5 6V11.25C1.5 11.8467 1.73705 12.419 2.15901 12.841C2.58097 13.2629 3.15326 13.5 3.75 13.5H17.25C17.8467 13.5 18.419 13.2629 18.841 12.841C19.2629 12.419 19.5 11.8467 19.5 11.25V6H1.5Z"
                    fill={active === "my-jobs" && !profile ? "white" : "black"}
                />
            </svg>
        ),
        "my-account": (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6 mr-3"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
                />
            </svg>
        ),
        "logout": (
            <svg
                width="17"
                height="20"
                viewBox="0 0 384.971 384.971"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-4"
            >
                <path
                    d="M180.455,360.91H24.061V24.061h156.394c6.641,0,12.03-5.39,12.03-12.03s-5.39-12.03-12.03-12.03H12.03
			C5.39,0.001,0,5.39,0,12.031V372.94c0,6.641,5.39,12.03,12.03,12.03h168.424c6.641,0,12.03-5.39,12.03-12.03
			C192.485,366.299,187.095,360.91,180.455,360.91z"
                    fill={active === "logout" && !profile ? "white" : "black"}
                />
                <path
                    d="M381.481,184.088l-83.009-84.2c-4.704-4.752-12.319-4.74-17.011,0c-4.704,4.74-4.704,12.439,0,17.179l62.558,63.46H96.279
			c-6.641,0-12.03,5.438-12.03,12.151c0,6.713,5.39,12.151,12.03,12.151h247.74l-62.558,63.46c-4.704,4.752-4.704,12.439,0,17.179
			c4.704,4.752,12.319,4.752,17.011,0l82.997-84.2C386.113,196.588,386.161,188.756,381.481,184.088z"
                    fill={active === "logout" && !profile ? "white" : "black"}
                />
            </svg>
        )
    }

    return (
        <>
            <span
                className="hover:shadow-md cursor-pointer py-4 items-center rounded-md flex justify-start pl-4"
                style={{
                    backgroundColor:
                        active === value && !profile ? "#2EBAA3" : "",
                    color: active === value && !profile ? "white" : "black",
                    width: "205px",
                    marginRight: "37px"
                }}
                onClick={() => {
                    if (value === "logout") {
                        localStorage.removeItem("persist:root");
                        localStorage.removeItem("userId");
                        localStorage.removeItem("rft");
                        localStorage.removeItem("newPassword");
                        localStorage.removeItem("email");
                        dispatch(setLogout());
                        navigate(`/dashboard/${value}`);
                    } else {
                        setActive(value);
                        // navigate(`/dashboard/${value !== "dashboard" ? value != "my account" ? value : "myaccount" : ""}`);
                        navigate(`/dashboard/${value !== "dashboard" ? value.replace(/\s+/g, '') : ""}`)
                        // setProfile(false);
                    }
                    if (value === "timesheets") {
                        setSelectedTimesheet(null)
                    }
                }}
            >
                {svg[value]}

                {capitalizeFirstLetter(value.replace(/-/g, ' '))}
            </span >
        </>
    )
}
